<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <Tire />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import Tire from '@/components/settings/atendimentos/tire/Tire'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'Tires',
  components: {
    PageTitle,
    PageRowWrapper,
    Tire,
    LoadingPage
  }
}
</script>
